import { tryLoadDependencies, WebAwesomeComponent } from '../Global/loadDependecy'

const documentUploadTemplate = document.createElement('template')
documentUploadTemplate.innerHTML = `
<style>
.file-upload {
  border: 1px solid #ccc;
  padding: 1rem;
  border-radius: 8px;
  max-width: 350px;
}
.drop-area {
  border: 2px dashed #aaa;
  border-radius: 6px;
  padding: 2rem;
  text-align: center;
  cursor: pointer;
  margin-bottom: 1rem;
  transition: background 0.2s;
}
.drop-area.drag-over {
  background: #e0f7fa;
  border-color: #26c6da;
}
.status {
  margin-top: 1rem;
  color: green;
}
</style>
  <div class="file-upload">
    <div class="drop-area"
      <p>Drag & drop a file here, or click to select</p>
      <p>Selected files: <ul class="file-names"></ul></p>
      <input type="file" style="display: none;" />
    </div>
    <wa-button><slot name="uploadButtonText"></slot></wa-button>
    <div class="status"><slot name="status"></slot></div>
  </div>
`
class DocumentUpload extends HTMLElement {
  private selectedFiles: File[] = []

  constructor() {
    super()

    tryLoadDependencies(document, [WebAwesomeComponent.Button])

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(documentUploadTemplate.content.cloneNode(true))
  }

  filterSelectedFilesFunction?: (item: any) => boolean

  connectedCallback() {
    const dropArea = this.shadowRoot?.querySelector('.drop-area')
    if (dropArea) {
      // Click to open file dialog
      dropArea.addEventListener('click', () => {
        const fileInput = this.shadowRoot?.querySelector('input[type="file"]')
        if (fileInput) {
          // TBD fileInput.click()
        }
      })

      // Drag over
      dropArea.addEventListener('dragover', (e) => {
        e.preventDefault()
        dropArea.classList.add('drag-over')
      })

      // Drag leave
      dropArea.addEventListener('dragleave', (e) => {
        e.preventDefault()
        dropArea.classList.remove('drag-over')
      })

      // Drop
      dropArea.addEventListener('drop', (e) => {
        e.preventDefault()
        dropArea.classList.remove('drag-over')
        const eDrag = e as DragEvent
        const files = eDrag.dataTransfer?.files
        if (files && files.length > 0) {
          this.onFilesSelected(files)
        }
      })
    }
  }

  private onFilesSelected(files: FileList) {
    if (files.length > 0) {
      // When you need to filter:
      this.selectedFiles = Array.from(files).filter((item) =>
        this.filterSelectedFilesFunction ? this.filterSelectedFilesFunction(item) : true,
      )

      const filesList = this.shadowRoot?.querySelector('.file-names')
      if (filesList) {
        filesList.innerHTML = this.selectedFiles.map((file) => `<li>${file.name}</li>`).join('')
      }
      this.dispatchEvent(
        new CustomEvent('file-selected', { detail: { files: this.selectedFiles } }),
      )
    }
  }
}

if (!customElements.get('ts-document-upload')) {
  customElements.define('ts-document-upload', DocumentUpload)
}
export { DocumentUpload }
